import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MicrosoftGeneralSettings } from '../../shared/models/generated/ziroModels';

@Injectable()
export class MicrosoftGeneralSettingsResource {
  private http = inject(HttpClient);

  private _url = '/services/microsoft/admin/general-settings';

  get(): Observable<MicrosoftGeneralSettings> {
    return this.http.get<MicrosoftGeneralSettings>(this._url);
  }

  put(settings: MicrosoftGeneralSettings): Observable<void> {
    return this.http.put<void>(this._url, settings);
  }
}
